import {_} from 'vue-underscore'

export const ExtendCurtainTemplate = {
  methods: {
    // mapping utils
    translateSizeDefinitionValidation(item) {
      if (this.hasValidationRules(item)) {
        const max = item.max
        const min = item.min
        return `required|double:1|min_value:${min}|max_value:${max}`
      }
      return "required|double:1"
    },
    hasValidationRules(templateDefinition) {
      return !!(templateDefinition.min || templateDefinition.max);
    },
    mapProperties(template, predict, extend) {
      return _.mapObject(
        _.pick(template, predict), extend
      )
    },

    // main method
    mapTemplateDefinitions(template) {
      const sizeDefinitionPredict = (value, key) => {
        return value && key.includes('definition') && _.has(value, 'increment')
      }
      const sizeDefinitionExtend = (value, key) => {
        return {
          ...value,
          template_key: key,
          schemaExtension: {
            type: "text",
            validation: this.translateSizeDefinitionValidation(value),
            id: key.replace("_definition", "")
          }
        }
      }

      const booleanDefinitionPredict = (value, key) => {
        return value && key.includes('definition') && _.has(value, 'hidden')
      }
      const booleanDefinitionExtend = (value, key) => {
        return {
          ...value,
          template_key: key,
          schemaExtension: {
            type: "checkbox",
            id: key.replace("_definition", "")}
          }
      }

      return {
        sizeDefinitions: this.mapProperties(template, sizeDefinitionPredict, sizeDefinitionExtend),
        booleanDefinitions: this.mapProperties(template, booleanDefinitionPredict, booleanDefinitionExtend),
      }
    },
    // This method returns extended template.
    // Logic: for all template properties which has 'definition' keyword
    // it picks sizeDefinitions and booleanDefinitions
    // and adds some extra object `schemaExtension` with a payload
    // to mix it into flow question
    extendTemplate(template) {
      const {sizeDefinitions, booleanDefinitions} = this.mapTemplateDefinitions(template)
      return {
        ...template,
        ...sizeDefinitions,
        ...booleanDefinitions
      }
    }
  }
}

export const DynamicTemplateTranslator = {
  mixins: [ExtendCurtainTemplate],
  methods: {
    // for mapping data to make dynamic extending
    translateCurtainTemplate(template) {
      const {sizeDefinitions, booleanDefinitions, availableChoices} = this.mapTemplateDefinitions(template)

      const {sizeValidations, sizePredefines} = this.translateSizeDefinitions(sizeDefinitions)
      const {booleanPredefines} = this.translateBooleanDefinitions(booleanDefinitions)

      const validations = {...sizeValidations}
      const choices = {...availableChoices}
      const predefines = {
        ...sizePredefines,
        ...booleanPredefines
      }
      return {
        validations,
        choices,
        steps: [],
        predefines
      }
    },
    translateSizeDefinitions(definitions) {
      let sizeValidations = {}
      let sizePredefines = {}
      definitions.forEach((item, key) => {
        sizeValidations[key] = this.translateSizeDefinitionValidation(item)
        if (item.default) {
          sizePredefines[key] = item.default
        }
      })

      return {
        sizeValidations,
        sizePredefines
      }
    },
    translateBooleanDefinitions(definitions) {
      return definitions
    },
  }
}